import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {CdkDrag, CdkDragDrop, CdkDropList} from "@angular/cdk/drag-drop";
import {TableDisplayConfig} from '../../../entities/table-display-config.entity';
import {NgForOf, NgIf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {BsModalRef, BsModalService, ModalModule} from 'ngx-bootstrap/modal';
import {Backend} from '@generated-backend-types';
import TableFilterDisplayTypeEnum = Backend.App.Enums.TableFilterDisplayTypeEnum;

@Component({
  selector: 'app-table-column-sorter[tableDisplayConfig]',
  templateUrl: './table-column-sorter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkDrag, CdkDropList, NgIf, TranslatePipe, NgForOf, ModalModule],
  providers: [BsModalService],
  standalone: true
})
export class TableColumnSorterComponent implements OnInit {

  public columnsModal?: BsModalRef
  @ViewChild('columnsModalTemplate') public columnsModalTemplate!: TemplateRef<unknown>

  @Output() resetTable: EventEmitter<void> = new EventEmitter<void>();
  @Output() public tableDisplayConfigChange: EventEmitter<TableDisplayConfig> = new EventEmitter<TableDisplayConfig>();
  @Output() public hiddenColumnsChanged: EventEmitter<string> = new EventEmitter<string>();
  public hiddenColumns: string[] = [];
  public columns: string[] = [];
  @Input() openListener!: EventEmitter<void>;
  protected readonly TableFilterDisplayTypeEnum = TableFilterDisplayTypeEnum;

  public constructor(
    private readonly modalService: BsModalService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  public _tableDisplayConfig?: TableDisplayConfig;

  @Input()
  public set tableDisplayConfig(conf: TableDisplayConfig | undefined) {
    if (!conf || conf.tableConfig?.id === undefined) {
      return;
    }
    this._tableDisplayConfig = conf;
    this.hiddenColumns = conf.hidden_columns?.split(',') ?? [];
    if (this.hiddenColumns[0] === '') {
      this.hiddenColumns = [];
    }


    const cols: string[] = [];
    conf.tableConfig.columns?.map(c => {
      if (c.visible) {
        cols.push(c.name)
      }
    })

    const sortOrderArray: string[] = conf.column_order?.slice()?.split(',') ?? [];

    // Sort the array based on the sortOrder
    cols.sort((a, b) => sortOrderArray.indexOf(a) - sortOrderArray.indexOf(b));
    this.columns = cols.slice();


    if (!conf.column_order) {
      this.tableDisplayConfigChange.next({...conf, column_order: cols.join(',')})
    }
    this.cdr.detectChanges()
  }

  public onColumnDrop(event: CdkDragDrop<string[]>) {

    if (!this._tableDisplayConfig) {
      return
    }
    this.columns = this.moveArrayItem(this.columns, event.previousIndex, event.currentIndex);
    this.cdr.markForCheck()
    this.tableDisplayConfigChange.next({...this._tableDisplayConfig, column_order: this.columns.join(',')})
  }

  public toggleColumn(name: string) {

    if (!this._tableDisplayConfig) {
      return
    }

    const index = this.hiddenColumns.findIndex(c => c === name)
    if (index > -1) {
      this.hiddenColumns.splice(index, 1);
    } else {
      this.hiddenColumns.push(name);
    }
    this.hiddenColumnsChanged.next(this.hiddenColumns.join(','))
  }

  public ngOnInit() {
    this.openListener.subscribe(
      () => {
        this.columnsModal = this.modalService.show(this.columnsModalTemplate)
      }
    )
  }

  private moveArrayItem<T>(array: T[], from: number, to: number): T[] {
    array.splice(to, 0, array.splice(from, 1)[0]);
    return array.slice();
  }
}
